import React from 'react';

interface ZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
}

const buttonStyle = { padding: '10px 20px', margin: 5, fontSize: 18, cursor: 'pointer', background: '#1976d2', color: 'white', border: 'none', borderRadius: 4 };

const ZoomControls: React.FC<ZoomControlsProps> = ({ onZoomIn, onZoomOut }) => (
  <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 100 }}>
    <button onClick={onZoomIn} style={buttonStyle}>+</button>
    <button onClick={onZoomOut} style={buttonStyle}>−</button>
  </div>
);

export default ZoomControls;

